import { render, staticRenderFns } from "./RegistroNotificacaoCadastro.vue?vue&type=template&id=ec3f0566&"
import script from "./RegistroNotificacaoCadastro.vue?vue&type=script&lang=js&"
export * from "./RegistroNotificacaoCadastro.vue?vue&type=script&lang=js&"
import style0 from "./RegistroNotificacaoCadastro.vue?vue&type=style&index=0&id=ec3f0566&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports